import { node, object, shape, string } from 'prop-types'

export default function Element({ attributes, children, element }) {
  attributes.style = attributes.style || {}
  if (element.align) attributes.style.textAlign = element.align
  if (element.color) attributes.style.color = element.color

  switch (element.type) {
    case 'paragraph':
      return <p {...attributes}>{children}</p>
    case 'headline1':
      return <h1 {...attributes}>{children}</h1>
    case 'headline2':
      return <h2 {...attributes}>{children}</h2>
    case 'headline3':
      return <h3 {...attributes}>{children}</h3>
    case 'blockquote':
      return <blockquote {...attributes}>{children}</blockquote>
    case 'unordered-list':
      return <ul {...attributes}>{children}</ul>
    case 'ordered-list':
      return <ol {...attributes}>{children}</ol>
    case 'list-item':
      return <li {...attributes}>{children}</li>
    case 'list-item-child':
      return <div {...attributes}>{children}</div>
    case 'link':
      return (
        <a
          {...attributes}
          href={element.url}
          target={element.isExternal ? '_blank' : ''}
          rel={element.isExternal ? 'noopener noreferrer' : ''}
        >
          {children}
        </a>
      )
    case 'button':
      return (
        <div {...attributes}>
          <a
            className="rich-text-button"
            href={element.url}
            target={element.isExternal ? '_blank' : ''}
            rel={element.isExternal ? 'noopener noreferrer' : ''}
          >
            {children}
          </a>
        </div>
      )
    default:
      return children
  }
}

Element.propTypes = {
  attributes: object,
  children: node,
  element: shape({ type: string.isRequired }).isRequired,
}
